import { Field } from 'formik'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { NumberField } from '../../field'

interface Props {
  name: string
  label?: string
  required?: boolean
  disabled?: boolean
  decimals?: number
}

export const NumberInput: React.FunctionComponent<Props> = ({ name, label, disabled, required, decimals }) => {
  const intl = useIntl()
  const validate = useCallback(
    (value: number | null): string | undefined => {
      if (required && !value) {
        return intl.formatMessage({ id: 'validation.requiredField' })
      }
      return undefined
    },
    [required, intl]
  )

  return (
    <Field
      component={NumberField}
      id={name}
      name={name}
      label={label}
      required={required}
      validate={validate}
      disabled={disabled}
      decimals={decimals}
      placeholder="N/A"
    />
  )
}
